// extracted by mini-css-extract-plugin
export var prevNextLink = "PrevNextLink-module--prevNextLink---mogR";
export var linkLineloop = "PrevNextLink-module--link-lineloop--3lwmB";
export var keyGnav = "PrevNextLink-module--key-gnav--25h9e";